@use "variables" as *;

.item {
  border-radius: 12px;
}

.container {
  width: 100%;
  display: flex;
}

.actionArea {
  display: flex;
  flex-grow: 1;
  height: 100%;
  padding: $spacing-s $spacing-l !important;
}

.name {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: left;
  width: 100%;
}

.readName {
  font-size: $fontSize-m;
  font-weight: normal;
  text-align: left;
  width: 100%;
}

.visibility {
  font-size: $fontSize-xxxs;
  font-weight: lighter;
  text-align: right;
  margin-left: $spacing-s;
}

.description {
  font-size: $fontSize-xs;
  font-weight: normal;
  white-space: pre-wrap;
  width: 100%;
  text-align: left;
  vertical-align: top;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.readDescription {
  font-size: $fontSize-xs;
  font-weight: normal;
}

.nonReadDescription {
  font-size: $fontSize-xs;
  font-weight: bold;
}

.severityMark {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 12px;
}
